let datetime = (date) => {
    const nDate = new Date(date);
    const year = nDate.getFullYear().toString().padStart(2, 0);
    const month = (nDate.getMonth() + 1).toString().padStart(2, 0);
    const day = nDate.getDate().toString().padStart(2, 0);
    const hour = nDate.getHours().toString().padStart(2, 0);
    const minute = nDate.getMinutes().toString().padStart(2, 0);
    // const second = nDate.getSeconds().toString().padStart(2, 0);
    return `${year}-${month}-${day} ${hour}:${minute}`;
}

let date = (date) => {
    const nDate = new Date(date);
    const year = nDate.getFullYear().toString().padStart(2, 0);
    const month = (nDate.getMonth() + 1).toString().padStart(2, 0);
    const day = nDate.getDate().toString().padStart(2, 0);
    return `${year}-${month}-${day}`;
}

let date_ch = (date) => {
    const nDate = new Date(date);
    const year = nDate.getFullYear().toString().padStart(2, 0);
    const month = (nDate.getMonth() + 1).toString().padStart(2, 0);
    const day = nDate.getDate().toString().padStart(2, 0);
    return `${year}年${month}月${day}日`;
}

let date_week_ch = (date) => {
    const nDate = new Date(date);
    const year = nDate.getFullYear().toString().padStart(2, 0);
    const month = (nDate.getMonth() + 1).toString().padStart(2, 0);
    const day = nDate.getDate().toString().padStart(2, 0);

    return `${year}年${month}月${day}日 星期${WEEKNames[nDate.getDay()]}`;
}

let html_text = (html) => {
    if (html) {
        var reg = new RegExp("<.+?>", "g");
        return html.replace(reg, "");
    }
    return "";
}

let lengthTwo = (val) => {
    if (val != null) {
        return val.toString().padStart(2, 0);
    }
    return "00";
}

const MINUTE = 1000 * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
const WEEK = DAY * 7;
const WEEKNames = ["日", "一", "二", "三", "四", "五", "六"];

let showtime = (datestr) => {
    let now = new Date();
    let dateVal = new Date(datestr);
    let dt = now.getTime() - dateVal.getTime();
    if (dt < HOUR) {
        let minute = dt / MINUTE;
        minute = Math.max(minute, 1);
        minute = Math.floor(minute);
        return minute + "分钟前";
    }
    if (dt < DAY) {
        let hour = dt / HOUR;
        hour = Math.max(hour, 1);
        hour = Math.floor(hour);
        return hour + "小时前";
    }
    if (dt < WEEK) {
        let day = dt / DAY;
        day = Math.max(day, 1);
        day = Math.floor(day);
        return day + "天前";
    }
    return date(datestr);
}

let hideTel = (tel)=>{
    if(tel){
        let telArr = tel.split('');
        telArr.forEach((element, index) => {
            if(index>2&&index<tel.length-4){
                telArr[index] = "*";
            }
        });
        return telArr.join('');
    }
    return "";
}

let reportNum = (num)=>{
    if(num){
        if(typeof num === 'number') {
			return num.toString().replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,'$&,');
		} else {
			return parseFloat(num).toString().replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,'$&,');
		}
    }
    return num;
}
let percent = (num)=>{
    if(num>=0){
        return (num*100) + "%";
    }
    return "";
}
export { datetime, date, date_ch, html_text, showtime, lengthTwo, date_week_ch, hideTel, reportNum, percent }